import IztContainer from './src/izt-container'

IztContainer.install = Vue => {
  Vue.component(IztContainer.name, IztContainer)
}

export default IztContainer